/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './updateEmail.defs'
export { main as default } from './updateEmail.defs'
